import React from 'react'

const Images = ( props ) => {
    return <img src={ props.url } alt={ props.txt } />
}

export default Images